import React from 'react';
import { JuniorHubScreen } from '../../components/home/JuniorHubScreen';
import { RITMO_ITEMS } from '../../lib/juniorTheme';

export default function RitmoHubPage() {
  return (
    <JuniorHubScreen
      eyebrow="Ritmo"
      title="Percusión corporal"
      subtitle="Palmas, patadas, chasquidos y pecho — siente el pulso con tu cuerpo."
      emoji="🥁"
      accent="coral"
      items={RITMO_ITEMS}
      columns={2}
    />
  );
}
